import { keyframes, styled } from "styled-components";
import { mobileBreakpoint } from "../../Configs/Config";

const LoadingBackground = styled.div`
    background: black;
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const LoadingTextContainer = styled.div`
    color: white;
    font-size: 25px;
    font-weight: 600;
    padding: 2rem;
`;
const LoadingBarContainer = styled.div`
    width: 30%;
    height: 5%;
    background: #1b1a1a;
    border-radius: 1rem;
    @media screen and (max-width: ${mobileBreakpoint}px) {
        width: 90%;
    }
`;
const LoadingBarFrames = keyframes`
    0%{
        width: 0%;
    }
    100%{
        width: 100%;
    }
`;

const LoadingBar = styled.div`
    animation: ${LoadingBarFrames} 0.3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    height: 100%;
    border-radius: 1rem;
    background: ${(props) => props.theme.gradient.default};
`;

export const LoadingOverlay = () => {
    return (
        <LoadingBackground>
            <LoadingTextContainer>LiquiBot</LoadingTextContainer>
            <LoadingBarContainer>
                <LoadingBar />
            </LoadingBarContainer>
        </LoadingBackground>
    );
};
